import React from 'react';
import type Immutable from 'immutable';
import config from 'react-global-configuration';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import ImageSlider from '../../../components/ImageSlider';
import type { MediaReferenceField } from '../../../types/uncinc_profile/helpers/media';
import type { ParagraphImageSlider as Type } from '../../../types/uncinc_profile/paragraphs';
import type { SiteDomain } from '../../../types';

interface ParagraphImageSliderProps {
  entity: ImmutableEntity<Type>;
  lazyload?: boolean;
}

const ParagraphImageSlider: React.FC<ParagraphImageSliderProps> = ({ entity, lazyload = true }) => {
  const currentDomain = config.get('CURRENT_DOMAIN') as SiteDomain;
  const isFullScreen = currentDomain === 'annual_report_regenboog';
  const images = entity.get('field_images') as unknown as Immutable.List<MediaReferenceField<'image'>>;

  return (
    <div className="ParagraphImageSlider mb-6 mb-lg-8">
      {isFullScreen ? (
        <ImageSlider
          images={images}
          isFullScreen
          lazyload={lazyload}
        />
      ) : (
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 col-lg-10 offset-md-1 offset-lg-1">
              <ImageSlider
                images={images}
                lazyload={lazyload}
              />
            </div>
          </div>
        </Container>
      )}
    </div>
  );
};

export default ParagraphImageSlider;
